import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import useAffordance from 'Hooks/useAffordance';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import HouseholdSummaryPageView from './View';

const HouseholdSummaryPageContainer = (props) => {
  const { userResource } = useUserContext();
  const {
    collection: householdSummaryResp,
    loading,
    loadingError,
  } = useAffordance(userResource?.relationship(fr.relationships.householdSummary.name).link('related'));

  return (
    <DataContainer
      component={HouseholdSummaryPageView}
      componentProps={{
        ...props,
        householdSummaryResp,
      }}
      loading={loading}
      loadingError={loadingError}
    />
  );
};

export default HouseholdSummaryPageContainer;
